"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmailFieldValue = void 0;
const arrays_1 = require("./arrays");
const email_validation_1 = require("@smartsuite/email-validation");
const isEmailFieldValue = (fieldValue) => {
    if (!(0, arrays_1.isArrayOfStringsValue)(fieldValue))
        return false;
    return fieldValue.every((value) => (0, email_validation_1.validateEmailAddress)(value));
};
exports.isEmailFieldValue = isEmailFieldValue;
